import { useState } from 'react';
import { Heading } from '../../../../components/base';
import Image from '../../../../components/Image';
import { SurveySwiper } from './detail/SurveySlider';


export const ChatFeedbackDialog: React.FC = ({ }) => {
    const [isOpen, setIsOpen] = useState(false);
   
    const openFeedback = process.env.REACT_APP_FEEDBACK === 'TRUE';
    
    return (
        openFeedback ? <div>
             <div className='feedback-banner' onClick={() => { setIsOpen(!isOpen) }}>
                <div className="contents-image"><Image url="images/comment_banner.gif"></Image></div>
                <Heading size="body2"><span className="description-emp">Works AI</span>을 위해<br /> 여러분의 의견을 주세요!</Heading>
            </div>
            <SurveySwiper isOpen={isOpen} onClose={()=> {setIsOpen(false)}}/>
        </div>: ''
    );
};